module.exports = __webpack_public_path__ + "media/images/ic_subscribed-073a545b03d9dcf9d72244b91f27cf53.svg";